{
  "header": {
    "nav": {
      "manifesto": "Manifesto",
      "insights": "Perspectivas",
      "services": "O Que Fazemos",
      "solutions": "Soluções",
      "about": "Quem Somos",
      "cases": "Cases"
    },
    "contact": "Orquestrar Agentes"
  },
  "hero": {
    "heading1": "Orquestração de",
    "heading2": "Agentes de IA Enterprise",
    "description": "Nós entendemos a operação da sua empresa, construímos agentes conectados aos seus sistemas, e acompanhamos tudo de perto até a IA virar parte real da rotina da empresa, gerando resultado mensurável.",
    "cta": "Como funciona",
    "manifesto": "Manifesto",
    "kicker": "Para operações complexas, alto volume de processos e times que precisam ganhar eficiência.",
    "proof": "Agentes funcionando em produção na sua empresa em menos de 4 semanas."
  },
  "valueProposition": {
    "items": [
      {
        "title": "Enterprise Agent Platform",
        "description": "Plataforma proprietária e model-agnostic. Avaliamos continuamente Anthropic, OpenAI, Google e diversos outros modelos para cada caso de uso. Você não fica preso a um provedor. Nós ajustamos de modelo sem reescrever o agente visando sempre o máximo resultado."
      },
      {
        "title": "Assessment → Build → Operate",
        "description": "Um ciclo completo para colocar agentes de IA em produção, com segurança, controle e aderência ao seu compliance.\nEntendemos onde a IA realmente faz sentido, desenhamos a orquestração alinhada aos processos, sistemas e requisitos, acompanhando tudo após a implementação."
      },
      {
        "title": "Agent Engineer embarcado",
        "description": "Um profissional sênior (60% técnico, 40% business) dentro da sua operação. Refina agentes, mantém integrações, gerencia incidentes, garante segurança e otimiza custo por token. Não é dev alocado. Não é consultor distante. É ownership técnico e operacional sobre a IA em produção na sua empresa."
      }
    ]
  },
  "services": {
    "label": "Modelo Operacional",
    "heading": "Do diagnóstico à operação contínua.",
    "description": "Três fases. Um ciclo. Operate é o coração: colocar agente em produção é o início, não o fim.",
    "explore": "Saiba mais",
    "cta": {
      "description": "Comece pelo Assessment e descubra onde a IA pode gerar valor real na sua operação.",
      "button": "Agendar Assessment"
    },
    "items": [
      {
        "title": "Assessment",
        "description": "Diagnóstico detalhado da sua operação. Entregáveis executivos: AI Score (mapa de maturidade), matriz de tarefas automatizáveis, arquitetura de agentes por função, análise de integrações, matriz de risco e business case com ROI estimado. Porta de entrada de baixo risco, você sai com um plano executável para implementação dos Agentes de IA moldados para sua operação."
      },
      {
        "title": "Build",
        "description": "Engenharia e implementação dos agentes na Plataforma Bravic, integrados ao seu ERP, CRM e qualquer sistema interno. Você recebe agentes em produção com sandbox, observabilidade, fallback humano e treinamento da equipe. Fazemos com que a IA entre em produção com controle, não como experimento solto."
      },
      {
        "title": "Operate",
        "description": "Operação contínua com Agent Engineer embarcado na sua empresa. Refinamento, manutenção, gestão de incidentes, otimização de custo por token, evolução com o negócio. Modelos mudam, sistemas evoluem, regras se ajustam, exceções aparecem. Sem operação contínua, qualquer sistema agêntico degrada em semanas. Operate é onde a inteligência opera conectada a sua operação."
      }
    ]
  },
  "stats": {
    "items": [
      {
        "value": "144h/mês",
        "label": "Horas operacionais eliminadas no fechamento do Scoder"
      },
      {
        "value": "38 → 97%",
        "label": "Registro de atendimento na JHSF Participações"
      },
      {
        "value": "≤ 4 sem",
        "label": "Do Assessment ao primeiro agente em produção"
      },
      {
        "value": "0",
        "label": "Lock-in com provedor de modelo. Plataforma model-agnostic."
      }
    ]
  },
  "insights": {
    "label": "Perspectivas",
    "heading": "Entenda como pensamos.",
    "readMore": "Ler artigo",
    "articles": [
      {
        "slug": "value-not-in-tool",
        "category": "Análise · Mercado",
        "title": "Por que o valor não está na ferramenta de IA",
        "description": "As plataformas vão comoditizar. Os modelos vão comoditizar. O que não comoditiza é entender o problema do cliente, construir a solução certa e operar continuamente. Quem dominar o processo captura o mercado."
      },
      {
        "slug": "agents-without-operation",
        "category": "Operação",
        "title": "O que acontece com agentes sem operação contínua",
        "description": "Modelos são atualizados. APIs depreciam. Regras de negócio mudam. Exceções aparecem. Sem alguém embarcado refinando prompts, mantendo integrações e otimizando custo, o sistema agêntico vira passivo silencioso — você só percebe quando a fatura chega."
      },
      {
        "slug": "orchestration-is-the-product",
        "category": "Arquitetura",
        "title": "A orquestração é o produto. O agente é peça.",
        "description": "Quando agentes deixam de ser ferramentas isoladas, a vantagem competitiva migra para a camada que decide quem faz o quê, quando, com qual contexto e sob qual regra."
      }
    ]
  },
  "cases": {
    "label": "Onde fizemos a IA deixar de ser promessa",
    "heading": "O que já entregamos.",
    "description": "Cada implementação mostra como a Bravic transforma oportunidades mapeadas no Assessment em agentes funcionando na rotina da empresa, com segurança, clareza e alinhado ao compliance.",
    "viewCase": "Ver case",
    "items": [
      {
        "category": "AUTOMAÇÃO OPERACIONAL · SOFTWARE HOUSE",
        "title": "Fechamento de horas mensais com NFS-e",
        "description": "144 horas/mês eliminadas. Processo reduzido de 7 dias para 1. Ciclo completo de apuração, validação, faturamento e pagamento de profissionais alocados em projetos, integrado a Jira, Sheets, Slack, Drive, Banco Inter e API municipal de NFS-e. Entregue para Scoder Tech Studio via Sugar Cane Tech.",
        "href": "/case-scoder"
      },
      {
        "category": "CRM & LEAD SCORING · REAL ESTATE",
        "title": "Atualização inteligente de leads via corretores e clientes",
        "description": "Taxa de registro de atendimento subiu de 38% para 97%. Tempo médio de atualização caiu de 3-5 dias para menos de 4 horas. Coleta de feedback do corretor por áudio e pesquisa pós-visita do cliente, integradas ao Salesforce com recálculo automático de score. Entregue para JHSF Participações via Sugar Cane Tech.",
        "href": "/case-jhsf"
      }
    ]
  },
  "cta": {
    "heading": "Orquestração de Agentes de IA Enterprise",
    "description": "A próxima vantagem operacional não virá de mais uma ferramenta. Virá da capacidade de colocar IA para trabalhar dentro da empresa, com segurança, governança e clareza de execução.\n\nA Bravic ajuda empresas a atravessar esse caminho: do diagnóstico à operação, com agentes conectados aos sistemas, aos processos e às regras do negócio.\n\nComece pelo Assessment e descubra onde a IA pode gerar valor real na sua operação.",
    "button": "Conversar com a Bravic"
  },
  "footer": {
    "description": "Da estratégia à produção, com agentes de IA conectados aos sistemas, processos e regras da sua empresa.",
    "deliveryLayers": "Modelo Operacional",
    "institutional": "Institucional",
    "globalHq": "Contato",
    "practiceAreas": ["Assessment", "Build", "Operate", "Plataforma Bravic"],
    "institutionalLinks": ["Manifesto", "Política de Privacidade", "Termos de Serviço"],
    "address": {
      "line1": "São Paulo, SP - Brasil",
      "line2": "",
      "phone": "+55 (35) 99975-3380",
      "email": "contato@bravicglobal.com.br"
    },
    "copyright": "© {{year}} Bravic. Todos os direitos reservados.",
    "offices": ["Brasil"],
    "manifesto": "Orquestração de Agentes de IA Enterprise"
  },
  "manifesto": {
    "hero": {
      "subtitle": "Manifesto Bravic",
      "heading": "INTELIGÊNCIA QUE OPERA.",
      "headingLine1": "ORQUESTRAÇÃO",
      "headingLine2": "DE",
      "headingHighlight": "AGENTES DE IA.",
      "quote": "O valor não está na ferramenta de IA. Está em entender o problema, construir a solução certa e operar continuamente, com resultado mensurável.",
      "statement": "Não vendemos plataforma. Não entregamos relatório com recomendações. Construímos agentes em produção e operamos ao lado do cliente, todos os dias."
    },
    "thesis": {
      "title": "A Tese",
      "box1": "Toda empresa vai precisar de agentes de IA. A maioria não vai conseguir implementar sozinha, com segurança, eficiência e resultado mensurável.",
      "box2": "Esse gap entre \"querer IA\" e \"ter IA funcionando\" é o território da Bravic. Nem ferramenta sem contexto de negócio, nem consultoria sem execução. Entendimento do problema, capacidade técnica de entrega e operação contínua ao lado do cliente — os três, juntos.",
      "narrative1": "O mercado está saturado de ferramentas de IA genéricas. A lista cresce toda semana. Plataformas vendem capacidade técnica, cobram por assento e deixam o cliente sozinho para descobrir como aplicar. Funciona para quem tem time técnico interno. Não funciona para 90% do mid-market. As consultorias tradicionais resolvem o outro lado pela metade: entregam estratégia sem execução. O relatório fica na gaveta. Os agentes nunca chegam.",
      "immutableTitle": "Operate é o coração",
      "immutableText": "Colocar agente em produção é o início, não o fim. Modelos são atualizados. Sistemas do cliente recebem deploy. Regras de negócio mudam. Exceções aparecem. Sem operação contínua, qualquer sistema agêntico degrada em semanas. O Agent Engineer embarcado é a peça que mantém os agentes vivos enquanto o negócio se transforma — e é o que separa um experimento abandonado de uma operação viva.",
      "narrative2": "Três premissas sustentam a tese. Primeira: a demanda vai continuar crescendo. Segunda: as ferramentas vão comoditizar, o diferencial não será qual se usa, mas como se usa. Terceira: um método replicável, documentado a ponto de poder ser ensinado, é o que combina qualidade de entrega com capacidade de escala. Consultoria não escala porque depende das mesmas pessoas. SaaS escala mas não resolve o problema do cliente. Framework documentado combina os dois.",
      "principleLabel": "Princípio Fundamental",
      "principleText": "As ferramentas vão comoditizar. Quem dominar o processo de implementação e operação captura o mercado."
    },
    "briefings": {
      "title": "COMO TRABALHAMOS",
      "viewAll": "Conheça o framework",
      "featured": {
        "category": "Framework",
        "title": "Assessment → Build → Operate",
        "link": "VER MODELO COMPLETO"
      },
      "internal": {
        "category": "Diferencial",
        "title": "Agent Engineer Embarcado",
        "description": "Profissional sênior, 60% técnico e 40% negócio. Dentro da operação do cliente até os agentes estarem em produção, entregando resultado mensurável, e depois. Não é dev alocado. Não é consultor distante. É a ponte entre o problema real e o agente em produção."
      },
      "case": {
        "label": "Plataforma",
        "title": "Enterprise Agent Platform",
        "description": "Proprietária e model-agnostic. Avaliamos continuamente Anthropic, OpenAI, Google e modelos open-source para cada caso de uso. Sem lock-in. Sem reescrever o agente para trocar de modelo."
      },
      "event": {
        "label": "Compliance",
        "title": "Diagnóstico, construção e operação contínua, com controle, segurança e aderência ao compliance da sua empresa."
      }
    },
    "cta": {
      "heading": "PRONTO PARA COMEÇAR?",
      "description": "Comece pelo Assessment. Diagnóstico estratégico com AI Score, roadmap executivo e ROI estimado. Porta de entrada de baixo risco, você sai com um plano executável, mesmo que decida não seguir para Build.",
      "requestConsulting": "Agendar Assessment",
      "downloadCapabilities": "Documento Institucional"
    }
  },
  "contact": {
    "hero": {
      "subtitle": "Contato",
      "headingLine1": "COMECE PELO",
      "headingHighlight": "ASSESSMENT.",
      "description": "Não vendemos horas. Não vendemos ferramentas. Trabalhamos com empresas dispostas a transformar áreas operacionais inteiras em operações agênticas supervisionadas, com resultado mensurável desde os primeiros meses."
    },
    "form": {
      "label": "Formulário",
      "heading": "Inicie a Conversa.",
      "description": "Preencha os campos abaixo. Retornaremos em até 24 horas para mapear seu cenário operacional.",
      "nameLabel": "Nome Completo",
      "namePlaceholder": "Seu nome",
      "emailLabel": "E-mail Corporativo",
      "emailPlaceholder": "nome@empresa.com",
      "companyLabel": "Empresa",
      "companyPlaceholder": "Nome da empresa",
      "serviceLabel": "Área de Interesse",
      "servicePlaceholder": "Selecione uma área",
      "services": [
        {
          "label": "Assessment — Diagnóstico Estratégico",
          "value": "diagnostics"
        },
        {
          "label": "Build — Engenharia e Implementação",
          "value": "orchestration"
        },
        {
          "label": "Operate — Operação Contínua",
          "value": "implementation"
        },
        {
          "label": "Ciclo Completo A → B → O",
          "value": "continuous"
        },
        {
          "label": "Consulta Inicial",
          "value": "consulting"
        }
      ],
      "messageLabel": "Mensagem",
      "messagePlaceholder": "Descreva brevemente o desafio operacional que pretende resolver.",
      "submitButton": "Enviar Mensagem",
      "sendingButton": "Enviando...",
      "successHeading": "Mensagem enviada.",
      "successMessage": "Um dos fundadores analisa seu cenário e responde em até 24 horas.",
      "errorMessage": "Erro ao enviar mensagem. Por favor, escreva diretamente para contato@bravicglobal.com.br"
    },
    "info": {
      "label": "Canais Diretos",
      "heading": "Outras Formas de Contato",
      "items": [
        {
          "icon": "mail",
          "title": "E-mail",
          "line1": "contato@bravicglobal.com.br",
          "line2": ""
        },
        {
          "icon": "phone",
          "title": "Telefone",
          "line1": "+55 (35) 99975-3380",
          "line2": ""
        },
        {
          "icon": "location_on",
          "title": "Escritório",
          "line1": "São Paulo, SP - Brasil",
          "line2": ""
        }
      ]
    }
  },
  "about": {
    "hero": {
      "subtitle": "Quem somos",
      "headingLine1": "TRANSFORMAMOS",
      "headingHighlight": "EMPRESAS.",
      "description": "Engenharia sênior aplicada à orquestração de agentes de IA enterprise. Diagnóstico, construção e operação contínua, com controle, segurança e aderência ao compliance da sua empresa.",
      "statement": "Toda afirmação aqui é sustentada por método, dado ou experiência. Clareza como sinal de competência."
    },
    "principles": {
      "label": "Princípios",
      "heading": "O Que Nos Guia",
      "items": [
        {
          "icon": "verified_user",
          "title": "Sustentado por Dado",
          "description": "Cada afirmação ancorada em método, número ou experiência real. Nenhuma promessa que não consigamos defender em uma sala com o seu CFO."
        },
        {
          "icon": "architecture",
          "title": "Engenharia Sênior",
          "description": "Saber construir e saber entregar. Profundidade técnica combinada com histórico de relacionamento com cliente, negociação de escopo e gestão de expectativa em ambiente enterprise."
        },
        {
          "icon": "engineering",
          "title": "Operação Embarcada",
          "description": "Não somos consultores distantes. O Agent Engineer fica dentro da operação do cliente até os agentes estarem em produção com controle, segurança e resultado mensurável, e continua depois, refinando, integrando, otimizando."
        },
        {
          "icon": "loop",
          "title": "Framework Replicável",
          "description": "Cada Assessment, Build e Operate é documentado como se estivesse sendo ensinado para outra pessoa. Um método replicável é o que combina qualidade de entrega com capacidade de escala."
        }
      ]
    },
    "team": {
      "label": "Fundadores",
      "heading": "Quem Constrói a Bravic",
      "members": [
        {
          "name": "Filipe Campos",
          "role": "Co-fundador",
          "bio": "Engenheiro de software e empreendedor com 18+ anos de experiência. Liderou projetos complexos em banking, energia, varejo e serviços digitais. Construiu e escalou uma empresa de software com mais de 30 engenheiros antes da Bravic."
        },
        {
          "name": "Brunno Romero",
          "role": "Co-fundador",
          "bio": "Engenheiro de software e consultor de IA para grandes empresas no Brasil e no exterior, com 15+ anos de experiência. Especialista em arquitetura de dados para treinamento de LLMs e liderança de times de integração — com foco em implantar IA em ambientes reais de produção, não em laboratório."
        }
      ]
    },
    "locations": {
      "label": "Operação",
      "heading": "Onde Estamos",
      "items": [
        {
          "number": "01",
          "city": "São Paulo · Campinas",
          "title": "Sede e operação",
          "description": "Equipe fundadora baseada em São Paulo e Campinas. Pilots ativos em campo. Operação enxuta — por escolha, não por restrição."
        }
      ]
    },
    "cta": {
      "heading": "Comece pelo Assessment.",
      "description": "Diagnóstico estratégico com AI Score, roadmap executivo e ROI estimado. Porta de entrada de baixo risco, você sai com um plano executável, mesmo que decida não seguir para Build.",
      "primaryButton": "Agendar Assessment",
      "secondaryButton": "Ver Cases"
    }
  },
  "articlePage": {
    "backLabel": "Perspectivas",
    "keyInsight": "Tese central",
    "takeaways": "Pontos-chave",
    "relatedMetrics": "Em síntese",
    "ctaHeading": "Comece pelo Assessment.",
    "ctaDescription": "Diagnóstico estratégico com AI Score, roadmap e ROI estimado. Porta de entrada de baixo risco, você sai com um plano executável, mesmo que decida não seguir para Build.",
    "ctaButton": "Conversar com a Bravic"
  },
  "articlePages": [
    {
      "slug": "value-not-in-tool",
      "category": "Análise · Mercado",
      "title": "Por que o valor não está na ferramenta de IA",
      "subtitle": "As plataformas vão comoditizar. Os modelos vão comoditizar. O diferencial será como se entende o problema, como se constrói a solução certa e como se opera continuamente.",
      "readTime": "5 min de leitura",
      "keyInsight": "Toda empresa vai precisar de agentes. A maioria não vai conseguir implementar sozinha, com segurança, eficiência e resultado mensurável. Esse gap entre 'querer IA' e 'ter IA funcionando' é o território real de captura de valor.",
      "content": [
        "O mercado está saturado de ferramentas de IA genéricas. A lista cresce toda semana. Cada uma promete tornar fácil construir um agente. Para quem tem time técnico interno, talvez seja. Para 90% do mid-market, é só mais uma camada de complexidade que ninguém tem tempo de dominar.",
        "Existe um gap que cresce a cada modelo lançado: a distância entre saber que IA é necessária e conseguir implementá-la com segurança, eficiência e resultado mensurável. Plataformas vendem capacidade técnica e cobram por assento ou execução. Consultorias tradicionais entregam relatório com recomendações. O cliente fica com um documento e zero agentes em produção.",
        "A tese da Bravic é simples. Ferramentas vão comoditizar. As plataformas de agentes vão ficar mais baratas e mais parecidas entre si, na mesma velocidade em que os modelos vão ficar mais capazes e mais intercambiáveis. O diferencial não será qual ferramenta se usa. Será como se usa.",
        "Quem captura valor sustentável combina três coisas: entendimento do problema do cliente, capacidade técnica de entrega e operação contínua ao lado dele. É a única posição que não é comoditizável tão cedo, porque depende de método, não de tecnologia.",
        "O moat se constrói com cada cliente. Quais prompts funcionam para cada tipo de processo. Quais integrações quebram e por quê. Quais padrões de exceção aparecem em cada setor. Como otimizar custo por token em cada caso. Esse conhecimento operacional se valoriza com cada mês de operação. E nenhum novo entrante consegue replicar sem o mesmo tempo de campo."
      ],
      "takeaways": [
        {
          "icon": "hub",
          "title": "Ferramenta não é diferencial",
          "description": "As plataformas vão comoditizar. O que sustenta valor é entender o problema, construir certo e operar continuamente."
        },
        {
          "icon": "engineering",
          "title": "Método é o moat",
          "description": "Um framework replicável que combina diagnóstico, engenharia e operação é o que escala sem perder qualidade."
        },
        {
          "icon": "visibility",
          "title": "Operação acumula dados",
          "description": "Cada mês de Operate gera conhecimento operacional proprietário — um ativo que se valoriza no tempo."
        }
      ],
      "metrics": [
        {
          "value": "A→B→O",
          "label": "Ciclo único Bravic"
        },
        {
          "value": "Embarcado",
          "label": "Agent Engineer no cliente"
        },
        {
          "value": "Recorrente",
          "label": "Operação, não projeto"
        },
        {
          "value": "Model-agnostic",
          "label": "Sem lock-in de provedor"
        }
      ]
    },
    {
      "slug": "agents-without-operation",
      "category": "Operação",
      "title": "O que acontece com agentes sem operação contínua",
      "subtitle": "\"Implante uma vez, esqueça para sempre\" é o mito mais caro em IA aplicada. Um sistema agêntico sem alguém embarcado degrada em semanas.",
      "readTime": "6 min de leitura",
      "keyInsight": "Colocar agente em produção é o início, não o fim. Modelos mudam, sistemas evoluem, processos se ajustam, exceções aparecem. Sem operação contínua, qualquer sistema agêntico vira passivo silencioso, e você só percebe quando a fatura chega.",
      "content": [
        "A promessa fácil: configure um agente uma vez e deixe rodar. A realidade técnica: os modelos de IA são atualizados, APIs depreciam, regras de negócio mudam, o contexto operacional do cliente se transforma. O que não muda sozinho é o agente. Esse é o problema.",
        "Sem alguém embarcado refinando prompts, mantendo integrações, gerenciando incidentes e otimizando custo por token, os desvios se acumulam em silêncio. Casos de exceção aparecem por setor e ninguém ajusta as regras. Integrações quebram quando o sistema do cliente recebe um deploy. O custo por tarefa sobe sem que ninguém perceba, até a fatura chegar.",
        "Operate é o coração do modelo Bravic por uma razão objetiva: é o que separa experimentos abandonados de operações vivas. Não é manutenção reativa. É supervisão contínua, refinamento, otimização de custo, evolução com o negócio do cliente. Reuniões quinzenais. Relatório mensal. Ajustes de prompts e integrações conforme o cliente muda.",
        "O Agent Engineer embarcado é a peça central desse modelo. Profissional sênior híbrido (60% técnico, 40% negócio) que vive dentro da operação do cliente todos os dias. Em muitos casos, entende a infraestrutura melhor que a própria equipe interna. Não por ser mais inteligente. Porque essa é a única coisa em que ele pensa.",
        "A pergunta certa a fazer a qualquer fornecedor de IA não é o quanto ele entrega no go-live. É quem mantém o sistema funcionando depois, e quanto isso custa em três, seis, doze meses."
      ],
      "takeaways": [
        {
          "icon": "engineering",
          "title": "Operate ≠ manutenção",
          "description": "É refinamento, evolução, otimização de custo e gestão de incidentes, a espinha dorsal de uma operação agêntica viva."
        },
        {
          "icon": "person",
          "title": "Agent Engineer embarcado",
          "description": "Profissional sênior híbrido que vive dentro da operação do cliente. Não é dev alocado. Não é consultor distante."
        },
        {
          "icon": "savings",
          "title": "Custo por token importa",
          "description": "Sem supervisão, o custo de tokens infla. A diferença entre operação cara e operação eficiente está no Operate."
        }
      ],
      "metrics": [
        {
          "value": "Embarcado",
          "label": "Na operação do cliente"
        },
        {
          "value": "Sênior",
          "label": "60% técnico · 40% negócio"
        },
        {
          "value": "Contínuo",
          "label": "Supervisão 24/7 do AE"
        },
        {
          "value": "Mensal",
          "label": "Relatório de eficiência"
        }
      ]
    },
    {
      "slug": "orchestration-is-the-product",
      "category": "Arquitetura",
      "title": "A orquestração é o produto. O agente é peça.",
      "subtitle": "Quando agentes deixam de ser ferramentas isoladas, a vantagem competitiva migra para a camada que decide quem faz o quê, quando, com qual contexto e sob qual regra.",
      "readTime": "7 min de leitura",
      "keyInsight": "Um agente sozinho é uma demo. Uma frota de agentes sem orquestração é caos com aparência de inovação. A camada que coordena, roteia tarefas, mantém memória compartilhada, arbitra conflitos e impõe política, é onde o software empresarial da próxima década vai ser ganho ou perdido.",
      "content": [
        "Por anos, a conversa sobre IA nas empresas girou em torno do agente como herói solitário. Um copiloto aqui. Um assistente ali. Cada área comprava o seu, cada fornecedor empacotava o seu, e cada um operava como ilha. Funcionou para demos. Não funciona para operação real. Quando uma decisão atravessa três áreas, sete sistemas e dezoito regras de compliance, o agente solitário trava, ou pior, decide errado com confiança.",
        "O salto que importa agora não é treinar agentes mais espertos. É construir a camada que faz vários agentes trabalharem como um sistema. Roteamento de tarefas. Memória compartilhada. Arbitragem de conflito. Política e auditoria. Essa camada tem nome: orquestração. E ela está se tornando o que bancos de dados foram nos anos 80 e o que APIs foram nos anos 2000, a infraestrutura silenciosa que separa quem opera de quem demonstra.",
        "Há uma diferença prática entre automação e operação agêntica que poucos executivos articulam com clareza. Automação executa um fluxo determinístico que alguém desenhou antes. Operação agêntica delega o desenho do fluxo ao próprio sistema, dentro de fronteiras definidas pelo negócio. O primeiro modelo escala mal porque exige um humano para cada exceção. O segundo escala porque trata a exceção como caso comum. A orquestração é o que torna o segundo modelo possível sem virar caixa-preta.",
        "Arquitetar isso exige decisões que não cabem em slides. Quem é a fonte da verdade quando dois agentes discordam? Como um agente passa contexto a outro sem vazar dado que não devia? Onde fica a memória de longo prazo, e quem decide o que esquecer? Que ações um agente pode tomar sozinho, e que ações exigem aprovação humana? Essas perguntas não são técnicas, são de governança. Quem responde antes de codar evita reescrever depois. Quem responde depois descobre, no auditor, que respondeu errado.",
        "O CTO que entender isso primeiro vai parar de comprar agentes e começar a desenhar a camada que os coordena. O que era stack de ferramentas vira sistema operacional do trabalho. E como todo sistema operacional, o vencedor não é o que tem mais features, é o que tem o modelo mental mais limpo de como agentes, dados, pessoas e regras coexistem. A próxima década do software empresarial não pertence ao agente mais esperto. Pertence à orquestra que o rege."
      ],
      "takeaways": [
        {
          "icon": "hub",
          "title": "Orquestração é a nova camada",
          "description": "A vantagem competitiva migrou do agente individual para o sistema que coordena vários agentes, dados e políticas em tempo real."
        },
        {
          "icon": "account_tree",
          "title": "Operação agêntica, não automação",
          "description": "Automação executa fluxos pré-desenhados. Operação agêntica delega o desenho ao sistema, dentro de fronteiras definidas pelo negócio."
        },
        {
          "icon": "policy",
          "title": "Governança antes de código",
          "description": "Fonte de verdade, memória, autonomia e aprovação humana são decisões de governança. Quem responde antes evita reescrever depois."
        }
      ],
      "metrics": [
        {
          "value": "Camada",
          "label": "Orquestração como infraestrutura, não feature"
        },
        {
          "value": "Sistema",
          "label": "Múltiplos agentes coordenados, não isolados"
        },
        {
          "value": "Política",
          "label": "Regras de negócio impostas em tempo de execução"
        },
        {
          "value": "Autonomia",
          "label": "Fronteiras claras entre decisão humana e agêntica"
        }
      ]
    }
  ],
  "roadmap": {
    "hero": {
      "headingLine1": "Assessment → Build →",
      "headingLine2": "Operate.",
      "description": "Três fases. Um ciclo. Do diagnóstico à operação contínua dos agentes, com controle, segurança e aderência ao compliance. Operate é o coração: colocar agente em produção é o início, não o fim."
    },
    "phase01": {
      "label": "Fase 01 · Assessment",
      "title": "Diagnóstico Estratégico",
      "quote": "Precisão no diagnóstico é o antídoto para a fricção operacional.",
      "description": "",
      "cards": [
        {
          "icon": "account_tree",
          "title": "Mapeamento de Processos",
          "description": "Mapa de alta fidelidade do processo operacional atual e dos fluxos de dados, do nível executivo ao operacional."
        },
        {
          "icon": "grid_guides",
          "title": "Matriz de Automação",
          "description": "Matriz que identifica e prioriza tarefas automatizáveis por impacto, esforço e viabilidade técnica."
        },
        {
          "icon": "smart_toy",
          "title": "Design de Agentes",
          "description": "Arquitetura dos agentes definida por função operacional específica, não um agente genérico, vários especializados."
        },
        {
          "icon": "security",
          "title": "Matriz de Governança",
          "description": "Avaliação de risco e framework de compliance ajustado ao seu setor e ao perfil de dados."
        },
        {
          "icon": "calculate",
          "title": "Business Case",
          "description": "Modelagem financeira com economia projetada, SLA e throughput, antes de qualquer investimento em construção."
        },
        {
          "icon": "hub",
          "title": "Integrações Necessárias",
          "description": "Blueprint das integrações requeridas: ERP, CRM, sistemas internos, APIs externas. Onde estão, como conectam."
        }
      ]
    },
    "phase02": {
      "label": "Fase 02 · Build",
      "title": "Engenharia e Implementação",
      "description": "Agentes sob medida construídos na Plataforma Bravic, integrados ao seu ERP, CRM e qualquer sistema interno. Sandbox, observabilidade, fallback humano e treinamento da equipe. A IA entra em produção com controle, não como experimento solto.",
      "metric": "Plataforma",
      "metricLabel": "Proprietária e model-agnostic",
      "features": [
        {
          "icon": "check_circle",
          "title": "Deploy de Agentes Sob Medida",
          "description": "Agentes desenhados para a sua lógica de negócio, não templates ajustados."
        },
        {
          "icon": "monitoring",
          "title": "Dashboard de Observabilidade",
          "description": "Telemetria em tempo real de cada interação agêntica: latência, custo, qualidade, exceções."
        },
        {
          "icon": "menu_book",
          "title": "Playbooks de Fallback Humano",
          "description": "Protocolos claros para quando o agente deve passar a tarefa para um humano, e como esse handoff acontece."
        },
        {
          "icon": "school",
          "title": "Treinamento da Equipe",
          "description": "Workshops executivos e técnicos. Sua equipe entende o sistema, não só usa."
        }
      ]
    },
    "phase03": {
      "label": "Fase 03 · Operate",
      "title": "Operação Contínua",
      "description": "Operate é o coração do modelo. Agent Engineer embarcado na sua empresa, refinamento contínuo, gestão de incidentes, otimização de custo por token e evolução com o negócio. Modelos mudam, sistemas evoluem, regras se ajustam, exceções aparecem. Sem operação contínua, qualquer sistema agêntico degrada em semanas. Operate é onde a inteligência opera conectada à sua operação.",
      "cards": [
        {
          "icon": "engineering",
          "title": "Agent Engineer dedicado",
          "description": "Engenheiro dedicado ou compartilhado para ajustes, manutenção e evolução. A pessoa que conhece a sua operação."
        },
        {
          "icon": "query_stats",
          "title": "Monitoramento de Qualidade",
          "description": "Supervisão contínua de qualidade e comportamento dos agentes, para detectar drift antes que ele custe dinheiro."
        },
        {
          "icon": "savings",
          "title": "Otimização de Custos",
          "description": "Refinamento granular de uso de tokens e despesa por tarefa. O que era caro vira eficiente."
        },
        {
          "icon": "refresh",
          "title": "Revisões de Workflow",
          "description": "Revisões periódicas de regras e fluxos para adaptação a mudanças no negócio. O agente acompanha a empresa."
        },
        {
          "icon": "trending_up",
          "title": "Evolução do Sistema",
          "description": "Avaliação contínua de novos modelos. Quando um modelo melhor aparece, o agente migra. Sem reescrever."
        },
        {
          "icon": "hub",
          "title": "Saúde da Infraestrutura",
          "description": "Gestão proativa de todas as integrações e estabilidade das APIs. Quando o seu sistema muda, o agente sabe."
        }
      ]
    },
    "cta": {
      "heading": "Comece pelo Assessment.",
      "description": "Diagnóstico estratégico com AI Score, roadmap executivo e ROI estimado. Porta de entrada de baixo risco, você sai com um plano executável, mesmo que decida não seguir para Build.",
      "primaryButton": "Agendar Assessment"
    }
  },
  "institucional": {
    "title": "Documento Institucional",
    "year": "2026",
    "tagline": "Sua operação, <strong>operada com IA.</strong>",
    "subtitle": "Documento Institucional",
    "byLine": "by Sugar Cane Tech",
    "whoWeAre": {
      "title": "Quem Somos",
      "paragraphs": [
        "A <strong>Sugar Cane Tech</strong> é uma software house com <strong>6+ anos de experiência</strong> e <strong>mais de 30 projetos entregues</strong>, construindo software em múltiplas indústrias e níveis de complexidade.",
        "Somos especializados em alocar <strong>talentos de engenharia brasileiros de alto nível</strong> para empresas na <strong>Europa e Estados Unidos</strong>, além de entregar projetos de software sob medida de ponta a ponta, com forte experiência no <strong>setor de seguros</strong>.",
        "<strong>A Bravic foi construída sobre essa base.</strong>",
        "A <strong>Bravic</strong> é a plataforma de IA e o braço de inteligência da <strong>Sugar Cane Tech</strong>, focada em ajudar empresas a realmente <strong>operar com IA</strong>, não apenas experimentar. Foi fundada por engenheiros com profunda experiência em construir e escalar negócios de software.",
        "<a href=\"https://www.linkedin.com/in/filipecps\" target=\"_blank\" rel=\"noopener noreferrer\"><strong>Filipe Campos</strong></a> é engenheiro de software e empreendedor com <strong>18+ anos de experiência</strong>. Liderou projetos complexos em banking, energia, varejo e serviços digitais, e anteriormente construiu e escalou uma empresa de software com <strong>mais de 30 engenheiros</strong>.",
        "<a href=\"https://www.linkedin.com/in/brunno-romero\" target=\"_blank\" rel=\"noopener noreferrer\"><strong>Brunno Romero</strong></a> é engenheiro de software e consultor de IA para grandes empresas no Brasil e no exterior, com <strong>15+ anos de experiência</strong>. É especialista em arquitetura de dados para treinamento de LLMs e liderança de times de integração, com foco em implantar IA em <strong>ambientes reais de produção</strong>.",
        "Trabalhamos <strong>lado a lado</strong> com empresas para identificar oportunidades de alto impacto, implementar workflows de IA e integrar inteligência nas operações do dia a dia.",
        "Nossa abordagem é simples: <strong>ciclos curtos, entregas rápidas e resultados reais em semanas</strong>."
      ]
    },
    "problem": {
      "title": "O Problema",
      "subtitle": "O que descobrimos ao conversar com várias empresas",
      "intro": "Nos últimos meses, conversamos com empresas de diferentes portes e segmentos sobre como estão adotando inteligência artificial. O que encontramos foi um <strong>padrão claro</strong>: quase todas estão tentando usar IA, mas de formas <strong>desconexas, sem escala e sem uma estratégia</strong> que sustente os resultados. Os problemas se repetem:",
      "items": [
        {
          "title": "Iniciativas isoladas, sem visão de conjunto",
          "description": "Cada área tenta resolver seu próprio problema com IA, mas ninguém conecta os pontos. O resultado são ferramentas soltas, esforços duplicados e zero sinergia."
        },
        {
          "title": "Automações que não escalam",
          "description": "Muitas empresas automatizam tarefas pontuais, mas sem uma arquitetura pensada para crescer. Quando a demanda aumenta, tudo quebra."
        },
        {
          "title": "Dados presos em silos",
          "description": "A IA precisa de dados, mas eles estão espalhados em sistemas que não conversam entre si. Sem integração, qualquer modelo entrega menos do que poderia."
        },
        {
          "title": "Resultados que ninguém consegue medir",
          "description": "Projetos de IA são lançados, mas sem métricas claras de impacto. Sem medir, é impossível justificar investimento ou evoluir."
        },
        {
          "title": "Falta de padronização e governança",
          "description": "Cada equipe usa IA de um jeito diferente, sem padrões de qualidade, segurança ou compliance. Isso cria riscos invisíveis que crescem silenciosamente."
        },
        {
          "title": "Risco real de vazamento de dados",
          "description": "Com o uso crescente de IA generativa, informações sensíveis da empresa ficam expostas, e poucas empresas têm políticas claras para lidar com isso."
        }
      ]
    },
    "whatWeDo": {
      "title": "O Que Fazemos",
      "subtitle": "Nossos 3 pilares de atuação",
      "intro": "Depois de implementar IA em diferentes empresas e contextos, percebemos que os mesmos desafios se repetiam: falta de clareza sobre onde a IA gera valor, sistemas que não estão prontos para se conectar com agentes, e automações construídas sem estrutura para escalar. Foi a partir desses padrões que criamos um <strong>framework replicável em 3 etapas</strong>, pensado para levar qualquer empresa do diagnóstico à automação real, de forma rápida, mensurável e sem dependência de plataforma.",
      "pillars": [
        {
          "num": "01",
          "engTitle": "Assessment",
          "ptTitle": "Diagnóstico Estratégico",
          "description": "Mapeamos processos, identificamos gargalos e desenhamos a arquitetura de agentes com viabilidade técnica e financeira validada. Entregável principal: AI Score, com Escala de Maturidade de IA como componente."
        },
        {
          "num": "02",
          "engTitle": "Build",
          "ptTitle": "Implementação",
          "description": "Conectamos seus sistemas via MCP, construímos e implantamos agentes customizados na nossa plataforma própria, tudo junto com sua equipe."
        },
        {
          "num": "03",
          "engTitle": "Operate",
          "ptTitle": "Operação Contínua",
          "description": "Monitoramento, otimização de custos, evolução dos agentes e suporte dedicado para que sua operação com IA nunca pare de melhorar."
        }
      ]
    },
    "discovery": {
      "label": "01  —  ASSESSMENT",
      "paragraphs": [
        "Utilizamos formulários estratégicos que funcionam como um <strong>guia dentro dos processos da empresa</strong>. Esse formulário é compartilhado desde a diretoria e ecoa por todas as áreas nas quais faça sentido, todo o conhecimento gerado é <strong>propriedade exclusiva da empresa contratante</strong>.",
        "Após o formulário ser respondido, realizamos uma <strong>análise conjunta entre nossos consultores e os líderes de operação</strong> para atribuir pesos, prioridades e identificar marcadores de resultado que viabilizem as automações. Vale destacar: nem sempre a solução é IA, às vezes uma <strong>automação simples resolve de forma mais rápida e econômica</strong>, e nós indicamos isso.",
        "Esse processo também nos ajuda a entender onde a empresa se encontra no momento, através da nossa <strong>Escala de Maturidade de IA</strong>:"
      ],
      "maturityLevels": [
        {
          "level": 1,
          "zone": "risk",
          "title": "Consciência",
          "description": "Sabe que IA é importante, mas nada mudou."
        },
        {
          "level": 2,
          "zone": "risk",
          "title": "Shadow AI",
          "description": "Usam IA por conta própria, sem padrão."
        },
        {
          "level": 3,
          "zone": "risk",
          "title": "Padronização",
          "description": "Regras criadas, risco reduzido, sem transformação."
        },
        {
          "level": 4,
          "zone": "transition",
          "title": "IA em processos",
          "description": "IA em workflows, mas alguém ainda executa."
        },
        {
          "level": 5,
          "zone": "transition",
          "title": "Consciência de negócio",
          "description": "IA acessa dados internos com contexto real."
        },
        {
          "level": 6,
          "zone": "automation",
          "title": "Autonomia supervisionada",
          "description": "IA executa, humano supervisiona."
        },
        {
          "level": 7,
          "zone": "automation",
          "title": "Times de IA por função",
          "description": "Cada área com agentes próprios. Papéis mudam."
        },
        {
          "level": 8,
          "zone": "automation",
          "title": "Inteligência unificada",
          "description": "IAs conectadas entre áreas, inteligência compartilhada."
        },
        {
          "level": 9,
          "zone": "automation",
          "title": "Feedback contínuo",
          "description": "IA aprende, se adapta e evolui com o negócio."
        }
      ],
      "maturityLabels": {
        "risk": "Risco (1-3)",
        "transition": "Transição (4-5)",
        "automation": "Automação (6-9)"
      },
      "closing": [
        "Além do mapeamento, o Discovery inclui uma <strong>análise de viabilidade técnica e financeira</strong> de cada agente ou automação: calculamos os <strong>custos de tokens</strong>, validamos os <strong>melhores modelos</strong> para resolver cada problema e estimamos o <strong>custo operacional</strong> de cada solução. Com isso, conseguimos atestar a viabilidade — ou não viabilidade — de cada automação antes de investir na construção.",
        "Com tudo isso em mãos — diagnóstico, pesos, prioridades, score de maturidade e viabilidade validada — temos os dados necessários para apontar <strong>quick wins</strong>, identificar <strong>problemas comuns entre áreas</strong>, mapear as <strong>automações necessárias</strong> e construir um <strong>roadmap completo</strong> com estimativas de custo para implantação de cada agente. A partir daqui, estamos prontos para a próxima etapa."
      ]
    },
    "build": {
      "label": "02  —  BUILD",
      "paragraphs": [
        "Para cada automação priorizada no Assessment, começamos conectando seus <strong>ERPs, bases de dados, sistemas internos e ferramentas do dia a dia</strong> a uma camada que os agentes conseguem acessar e operar. Todo esse trabalho é feito através de interfaces <strong>MCP (Model Context Protocol)</strong>, o protocolo aberto adotado por praticamente todos os grandes players de IA como padrão de comunicação com agentes.",
        "Cada integração criada pode ser <strong>reaproveitada por múltiplos agentes</strong>. Uma conexão com seu ERP, por exemplo, serve tanto para um agente financeiro quanto para um de logística. Conforme avançamos, a <strong>implementação se acelera</strong>, porque a base já está construída.",
        "Com os sistemas conectados, partimos para a <strong>criação, documentação, operacionalização e validação dos agentes</strong> — sempre em conjunto com os usuários finais. Toda a construção é feita dentro da <strong>nossa própria plataforma</strong>, desenvolvida para ser <strong>agnóstica a modelo e provider</strong> (utilizamos Anthropic como base, mas podemos migrar para qualquer outro provedor).",
        "As automações podem assumir diferentes formatos: desde <strong>agentes com personas e papéis definidos</strong> que operam de forma autônoma, até <strong>integrações simples</strong> que podem ser acionadas via Slack, Teams, e-mail, WhatsApp ou qualquer outro canal já utilizado pela empresa."
      ],
      "note": "Importante: todo o nosso entregável — mapa de processos, especificações e prompts dos agentes — é totalmente transponível para outras plataformas. Não criamos dependência."
    },
    "operate": {
      "label": "03  —  OPERATE",
      "paragraphs": [
        "Agentes em produção precisam de <strong>acompanhamento contínuo</strong>. Na etapa Operate, garantimos que sua operação com IA evolua constantemente — com monitoramento ativo, otimização de custos e refinamento dos agentes.",
        "Através da nossa plataforma, temos controle total sobre <strong>telemetria, acompanhamento de gastos, monitoramento de qualidade dos modelos e testes A/B</strong> de resultados. Geramos <strong>relatórios mensais</strong> detalhados de todas as automações e custos de operação.",
        "Sua empresa conta com acesso a um <strong>Agent Engineer dedicado ou compartilhado</strong> para ajustes e manutenção em tempo real. Conforme a operação amadurece, identificamos novas oportunidades de automação e expandimos a rede de agentes, criando um <strong>ciclo contínuo de evolução</strong>."
      ],
      "note": "A operação contínua é o que diferencia projetos pontuais de uma transformação real. Aqui, IA deixa de ser experimento e vira infraestrutura."
    },
    "differentials": {
      "title": "Nossos Diferenciais",
      "items": [
        {
          "title": "Sem dependência de modelo ou provedor",
          "description": "Nossa plataforma é <b>agnóstica a modelos e provedores</b>. Você está protegido contra flutuações de preço de tokens — migramos para qualquer modelo disponível no mercado, sempre buscando o <b>melhor custo-benefício</b>, sem impacto nas suas automações."
        },
        {
          "title": "Abordagem corpo a corpo",
          "description": "Não somos consultores distantes. Estamos dentro da operação, identificando oportunidades e implementando soluções junto com a sua equipe."
        },
        {
          "title": "Ciclos curtos, resultados em semanas",
          "description": "Entregas em sprints curtas. Resultado concreto nas primeiras semanas. Nada de projetos intermináveis."
        },
        {
          "title": "Experiência comprovada",
          "description": "Mais de 30 projetos entregues pela Sugar Cane Tech. Fundadores com +13 anos de mercado em engenharia de software."
        },
        {
          "title": "Do diagnóstico à implementação",
          "description": "Cobrimos todo o ciclo: desde encontrar onde a IA faz sentido até colocar os agentes em produção integrados aos seus sistemas."
        },
        {
          "title": "Evolução real na maturidade de IA",
          "description": "Usamos nossa <b>Escala de Maturidade de IA</b> para medir onde sua empresa está e para onde precisa ir. Cada entrega faz a operação avançar na escala — saindo da zona de risco para a <b>automação real</b>, com resultados mensuráveis a cada etapa."
        }
      ]
    },
    "cases": {
      "title": "Cases de Sucesso",
      "items": [
        {
          "label": "CASE 01",
          "name": "Automatização do Fechamento de Horas Mensais com emissão de NFS-e",
          "logoKey": "scoder",
          "website": "www.scoder.com.br",
          "casePath": "/case-scoder"
        },
        {
          "label": "CASE 02",
          "name": "Atualização Inteligente de Leads via Corretores & Clientes",
          "logoKey": "jhsf",
          "website": "www.jhsf.com.br",
          "casePath": "/case-jhsf"
        }
      ]
    },
    "contact": {
      "title": "Vamos Conversar?",
      "heading": "Pronto para transformar sua operação com IA?",
      "email": "contato@bravicglobal.com.br",
      "webLabel": "Web:",
      "webUrl": "www.bravicglobal.com.br",
      "button": "Contato",
      "footerText": "by Sugar Cane Tech  |  IA Aplicada ao seu Negócio"
    }
  },
  "caseScoder": {
    "docLabel": "Caso · Scoder Tech Studio · entregue via Sugar Cane Tech",
    "cover": {
      "badge": "Caso de Sucesso",
      "title": "Automação do",
      "titleAccent": "Fechamento de Horas Mensais",
      "description": "Como a Scoder Tech Studio, software house com operações no Brasil e EUA, eliminou 144 horas/mês de trabalho operacional ao automatizar o ciclo de apuração, validação, faturamento e pagamentos das horas dos profissionais alocados em projetos de clientes — reduzindo o processo de",
      "descriptionHighlight": "7 dias para 1 dia",
      "clientLabel": "Cliente",
      "clientName": "Scoder Tech Studio",
      "clientTagline": "Software house · Brasil & EUA"
    },
    "flowchart": {
      "sectionLabel": "01 — Processo Automatizado",
      "title": "Fluxograma Operacional",
      "subtitle": "Mapeamento completo do processo end-to-end automatizado pela Bravic, do disparo inicial ao envio dos boletos e notas fiscais.",
      "legendProcess": "Etapa de Processo",
      "legendDecision": "Decisão",
      "legendLoop": "Espera / Retry",
      "legendYes": "Caminho aprovado",
      "legendNo": "Caminho de retorno"
    },
    "agents": {
      "sectionLabel": "02 — Arquitetura Multi-Agente",
      "title": "Hierarquia de Agentes",
      "subtitle": "Estrutura organizacional do sistema agentic implantado: um Orquestrador central delega para 3 Diretores especializados, que por sua vez coordenam 6 Sub-Agentes operacionais.",
      "legendOrchestrator": "Orquestrador",
      "legendDirectors": "Diretores",
      "legendSubAgents": "Sub-Agentes Operacionais"
    },
    "integrations": {
      "sectionLabel": "03 — Stack Tecnológica",
      "title": "Integrações Realizadas",
      "subtitle": "Sistemas conectados pelo agente de automação durante a execução do processo end-to-end de Fechamento de Horas Mensais.",
      "items": [
        {
          "icon": "assignment",
          "name": "Jira",
          "role": "Apuração de horas trabalhadas por profissional e projeto.",
          "tag": "REST API"
        },
        {
          "icon": "table_chart",
          "name": "Google Sheets",
          "role": "Validação cruzada de alocação e preenchimento da planilha de horas-cliente.",
          "tag": "Sheets API"
        },
        {
          "icon": "chat",
          "name": "Slack",
          "role": "Solicitação de aprovações de profissionais e gestores via DM.",
          "tag": "Web API"
        },
        {
          "icon": "mail",
          "name": "Google Workspace",
          "role": "Recebimento de NFs por e-mail e disparo dos boletos finais aos clientes.",
          "tag": "Gmail API"
        },
        {
          "icon": "folder",
          "name": "Google Drive",
          "role": "Armazenamento estruturado das notas fiscais validadas dos profissionais.",
          "tag": "Drive API"
        },
        {
          "icon": "account_balance",
          "name": "Banco Inter",
          "role": "Geração automática de boletos para clientes e PIX para profissionais.",
          "tag": "Open Banking"
        },
        {
          "icon": "assured_workload",
          "name": "Governo",
          "role": "Emissão automática de NFS-e via API municipal de nota fiscal eletrônica.",
          "tag": "API GOV",
          "tagVariant": "gov"
        }
      ]
    },
    "costs": {
      "sectionLabel": "04 — Investimento Mensal",
      "title": "Custos da Operação",
      "subtitle": "Detalhamento dos custos recorrentes para manter a automação do processo em produção.",
      "costHeader": "Composição do Custo Mensal",
      "costPill": "1 item · R$ 2.225,00",
      "costTotalLabel": "Custo total mensal",
      "costTotalValue": "R$ 2.225,00",
      "items": [
        {
          "label": "Operação Bravic",
          "detail": "Tokens in/out + Manutenção + SRE",
          "value": "R$ 2.225,00"
        }
      ],
      "roiLabel": "Retorno sobre o investimento",
      "roiTitle": "Economia Líquida",
      "roiGross": "Economia bruta mensal",
      "roiGrossValue": "+ R$ 10.320,00",
      "roiCost": "Custo da operação",
      "roiCostValue": "− R$ 2.225,00",
      "roiNetLabel": "Líquido / mês",
      "roiNetValue": "R$ 8.095",
      "roiPercent": "ROI sobre custo",
      "roiPercentValue": "364%",
      "roiAnnual": "Projeção anual líquida",
      "roiAnnualValue": "R$ 97.140,00"
    },
    "metrics": {
      "sectionLabel": "05 — Resultados Mensurados",
      "title": "Impacto da Automação",
      "subtitle": "Métricas consolidadas após a implementação do agente de automação no processo de Fechamento de Horas Mensais da Scoder Tech Studio.",
      "cards": [
        {
          "label": "Horas Economizadas",
          "value": "144",
          "unit": "h/mês",
          "delta": "3 cargos liberados de tarefas operacionais",
          "accent": "primary"
        },
        {
          "label": "Economia Financeira",
          "value": "R$ 10.320",
          "unit": "/mês",
          "delta": "R$ 123.840 projetados/ano",
          "accent": "success"
        },
        {
          "label": "Tempo do Processo",
          "value": "7 → 1",
          "unit": "dia",
          "delta": "↓ 86% de redução no ciclo",
          "accent": "warning"
        },
        {
          "label": "Visibilidade Gerencial",
          "value": "Relatórios Automatizados",
          "delta": "Análise por funcionário e projeto",
          "accent": "info",
          "smallValue": true
        }
      ],
      "breakdownTitle": "Breakdown · Horas Liberadas por Cargo",
      "breakdownPill": "144h · R$ 10.320,00 / mês",
      "breakdownHoursLabel": "Horas/mês",
      "breakdownRateLabel": "Custo/hora",
      "breakdownFooter": "Economia mensal consolidada",
      "breakdownFooterValue": "R$ 10.320,00",
      "breakdownItems": [
        {
          "role": "Auxiliar Financeiro",
          "hours": "84h",
          "rate": "R$ 30,00",
          "total": "R$ 2.520,00"
        },
        {
          "role": "Gerente de Projetos",
          "hours": "40h",
          "rate": "R$ 80,00",
          "total": "R$ 3.200,00"
        },
        {
          "role": "Diretor de Operações",
          "hours": "20h",
          "rate": "R$ 230,00",
          "total": "R$ 4.600,00"
        }
      ]
    },
    "footer": {
      "creditLabel": "Desenvolvido por",
      "creditText": "Sugar Cane Tech (entregue antes da Bravic, pela equipe fundadora)",
      "reportVersion": "Report v1.4 · Caso Scoder · Março 2026",
      "page": "Página"
    },
    "flow": {
      "step1Line1": "Buscar total de horas por",
      "step1Line2": "profissionais por projeto",
      "step2Line1": "Verificar se está condizente",
      "step2Line2": "com a planilha de alocação",
      "step3Line1": "Solicitar aprovação",
      "step3Line2": "do profissional",
      "decision1Line1": "Estão todos",
      "decision1Line2": "aprovados?",
      "loopWait": "AGUARDA",
      "loopTime": "1H",
      "no": "NÃO",
      "yes": "SIM",
      "r1Line1": "Receber NF",
      "r1Line2": "no E-mail",
      "r2Line1": "Validar e Salvar",
      "r2Line2": "no Drive",
      "r3Line1": "Validar benefícios",
      "r3Line2": "e gerar PIX",
      "l1Line1": "Preencher a Planilha",
      "l1Line2": "de horas clientes",
      "l2Line1": "Gerar Invoice",
      "decision2Line1": "Gestor",
      "decision2Line2": "Aprovou?",
      "loop2Line1": "Diz p/ o agente",
      "loop2Line2": "o que quer",
      "loop2Line3": "mudar ou",
      "loop2Line4": "refazer tudo",
      "l3Line1": "Gerar E-mails",
      "l4Line1": "Gerar Boleto",
      "l5Line1": "Gerar NFS-e",
      "finalLine1": "Enviar E-mails com",
      "finalLine2": "boleto e NFS-e"
    },
    "agentFlow": {
      "orchestratorTag": "ORCHESTRATOR",
      "orchestratorLine1": "Agente",
      "orchestratorLine2": "Orquestrador",
      "directorTag": "DIRECTOR",
      "dirTechLine1": "Diretor de",
      "dirTechLine2": "Tecnologia",
      "dirFinLine1": "Diretor Financeiro",
      "dirDelLine1": "Diretor de",
      "dirDelLine2": "Delivery",
      "subAgentTag": "SUB-AGENT",
      "subPmLine1": "Gerente de",
      "subPmLine2": "Projetos",
      "subTechLine1": "Líder Técnico",
      "subApLine1": "Contas a",
      "subApLine2": "Pagar",
      "subArLine1": "Contas a",
      "subArLine2": "Receber",
      "subFinLine1": "Auxiliar",
      "subFinLine2": "Financeiro",
      "subDelLine1": "Entregas"
    }
  },
  "caseJhsf": {
    "docLabel": "Caso · JHSF Participações · entregue via Sugar Cane Tech",
    "cover": {
      "badge": "Automação de CRM • Real Estate",
      "title": "Atualização Inteligente de",
      "titleAccent": "Leads",
      "titleLine2": "via Corretores & Clientes",
      "description": "Orquestração automática com duas trilhas paralelas: coleta de feedback do corretor (via áudio/texto) e pesquisa de satisfação do cliente (perguntas rápidas), ambos alimentando o Salesforce para enriquecer o lead e recalcular o scoring em tempo real.",
      "clientLabel": "Cliente",
      "clientName": "JHSF Participações",
      "clientTagline": "Real Estate & Hospitality • Alto Padrão",
      "clientLink": "jhsf.com.br"
    },
    "flowchart": {
      "sectionLabel": "Fluxo Operacional",
      "title": "Fluxograma de Atualização de Leads",
      "subtitle": "Orquestração automática com duas trilhas paralelas: coleta de feedback do corretor e pesquisa de satisfação do cliente, convergindo para recalcular o lead score no Salesforce.",
      "legendProcess": "Processo / Ação",
      "legendDecision": "Decisão",
      "legendLoop": "Espera / Retry",
      "legendYes": "Caminho positivo",
      "legendNo": "Caminho negativo"
    },
    "integrations": {
      "sectionLabel": "Ecossistema",
      "title": "Integrações & Sistemas",
      "subtitle": "Stack de ferramentas conectadas pelo agente para orquestrar o fluxo end-to-end de coleta, processamento e atualização de dados.",
      "items": [
        {
          "icon": "database",
          "name": "Salesforce CRM",
          "role": "Booking, gestão de leads, registro de atendimentos e lead scoring",
          "tag": "CRM",
          "tagVariant": "crm"
        },
        {
          "icon": "chat",
          "name": "WhatsApp Business",
          "role": "Coleta de feedback dos corretores (áudio/texto) e pesquisa de satisfação dos clientes pós-visita",
          "tag": "Messaging",
          "tagVariant": "msg"
        },
        {
          "icon": "bar_chart",
          "name": "Lead Scoring Engine",
          "role": "Recálculo automático do score combinando feedback do corretor e satisfação do cliente",
          "tag": "CRM",
          "tagVariant": "crm"
        },
        {
          "icon": "star",
          "name": "NPS & Satisfação",
          "role": "Pesquisa rápida pós-visita com o cliente avaliando corretor, imóvel e experiência geral",
          "tag": "Survey",
          "tagVariant": "survey"
        },
        {
          "icon": "sentiment_satisfied",
          "name": "Análise de Sentimento",
          "role": "Processa respostas abertas do cliente e áudio do corretor para extrair sentimento e insights",
          "tag": "AI",
          "tagVariant": "llm"
        },
        {
          "icon": "notifications",
          "name": "Alertas Inteligentes",
          "role": "Notificações automáticas ao gestor quando score muda ou NPS é crítico",
          "tag": "Messaging",
          "tagVariant": "msg"
        }
      ]
    },
    "metrics": {
      "sectionLabel": "Impacto",
      "title": "Métricas de Resultado",
      "subtitle": "Resultados projetados após 90 dias de operação do agente no funil de vendas JHSF.",
      "cards": [
        {
          "label": "Taxa de Registro de Atendimento",
          "value": "97",
          "unit": "%",
          "delta": "Antes: 38% dos atendimentos registrados",
          "accent": "primary"
        },
        {
          "label": "Tempo médio de atualização",
          "value": "< 4",
          "unit": "hrs",
          "delta": "Antes: 3-5 dias (quando registrado)",
          "accent": "success"
        },
        {
          "label": "Horas/mês economizadas",
          "value": "120",
          "unit": "hrs",
          "delta": "Equipe de 15 corretores",
          "accent": "warning"
        },
        {
          "label": "Precisão do Lead Score",
          "value": "+42",
          "unit": "%",
          "delta": "Dados reais vs. estimativas manuais",
          "accent": "info"
        },
        {
          "label": "Taxa de resposta cliente",
          "value": "72",
          "unit": "%",
          "delta": "Antes: 0% (não existia pesquisa)",
          "accent": "primary"
        },
        {
          "label": "NPS Capturado",
          "value": "78",
          "unit": "pts",
          "delta": "Visão em tempo real da satisfação",
          "accent": "success"
        },
        {
          "label": "Leads com duplo feedback",
          "value": "68",
          "unit": "%",
          "delta": "Feedback corretor + cliente combinados",
          "accent": "warning"
        },
        {
          "label": "Alertas críticos detectados",
          "value": "23",
          "unit": "/mês",
          "delta": "Clientes insatisfeitos resgatados a tempo",
          "accent": "info"
        }
      ]
    },
    "agents": {
      "sectionLabel": "Arquitetura",
      "title": "Estrutura de Agentes",
      "subtitle": "Hierarquia multi-agente: o Orchestrator monitora o Salesforce Booking, o Director coordena duas trilhas paralelas (corretor e cliente), e 5 sub-agentes especializados executam cada etapa.",
      "legendOrchestrator": "Orchestrator — monitora triggers",
      "legendDirectors": "Director — coordena pipeline",
      "legendSubAgents": "Sub-agente — executa tarefa específica"
    },
    "footer": {
      "creditLabel": "Desenvolvido por",
      "creditText": "JHSF — Inteligência Comercial",
      "reportVersion": "v1.0 • Abril 2026 • Case JHSF",
      "page": "Página"
    },
    "flow": {
      "triggerBadge": "TRIGGER • AGENDAMENTO DETECTADO",
      "triggerLine1": "Identificar agendamento",
      "triggerLine2": "no Salesforce Booking",
      "waitLabel1": "AGUARDA",
      "waitLabel2": "FIM DO DIA",
      "laneA": "TRILHA A • FEEDBACK CORRETOR",
      "laneB": "TRILHA B • FEEDBACK CLIENTE",
      "a1Badge": "WHATSAPP",
      "a1Line1": "Solicitar audio ou mensagem",
      "a1Line2": "descrevendo o atendimento",
      "a1DecisionLine1": "Corretor",
      "a1DecisionLine2": "respondeu?",
      "a1WaitLabel1": "AGUARDA",
      "a1WaitLabel2": "2H",
      "a1RetryNote": "Max 2 tentativas",
      "a2Badge": "AI AGENT",
      "a2Line1": "Transcrever audio e interpretar",
      "a2Line2": "feedback do corretor via IA",
      "a3Line1": "Gerar entrada de atendimento",
      "a3Line2": "estruturada no CRM",
      "a4Line1": "Atualizar dados do Lead",
      "a4Line2": "com info do atendimento",
      "extractLabel": "EXTRAI",
      "extractLine1": "Interesse, objecoes",
      "extractLine2": "sentimento, perfil",
      "b1Badge": "WHATSAPP",
      "b1Line1": "Enviar perguntas rapidas",
      "b1Line2": "ao cliente pos-visita",
      "b1QuestionsLabel": "PERGUNTAS",
      "b1Q1": "1. Nota atendimento",
      "b1Q2": "2. Nota do imovel",
      "b1Q3": "3. Interesse em revisita",
      "b1Q4": "4. Comentario livre",
      "b1DecisionLine1": "Cliente",
      "b1DecisionLine2": "respondeu?",
      "b1WaitLabel1": "LEMBRETE",
      "b1WaitLabel2": "24H",
      "b2Badge": "AI AGENT",
      "b2Line1": "Analisar sentimento e",
      "b2Line2": "categorizar respostas do cliente",
      "b3Line1": "Registrar avaliacao do",
      "b3Line2": "cliente no perfil do Lead",
      "b4Line1": "Atualizar NPS e indice",
      "b4Line2": "de satisfacao do Lead",
      "b3AnnotLabel": "SALVA NO CRM",
      "b3AnnotLine1": "Nota corretor, nota imovel",
      "b3AnnotLine2": "NPS, comentarios",
      "mergeLabel": "DADOS CONSOLIDADOS",
      "scoreLine1": "Recalcular Lead Score",
      "scoreLine2": "com dados combinados",
      "scoreDecisionLine1": "Score mudou",
      "scoreDecisionLine2": "significativamente?",
      "notifyLine1": "Notificar gestor comercial",
      "notifyLine2": "sobre mudanca de score do lead",
      "silentLine1": "Score atualizado",
      "silentLine2": "silenciosamente no CRM",
      "endLabel": "FLUXO CONCLUIDO",
      "bookingAnnotLabel": "DADOS DO BOOKING",
      "bookingAnnotLine": "Data, hora, imovel, corretor, cliente",
      "msgAnnotLabel": "MSG CORRETOR",
      "msgAnnotLine": "\"Como foi a visita?\""
    },
    "agentFlow": {
      "orchestratorRole": "ORCHESTRATOR",
      "orchestratorName": "Booking Monitor Agent",
      "directorRole": "DIRECTOR",
      "directorName": "Lead Enrichment Director",
      "laneCorretorLabel": "TRILHA CORRETOR",
      "laneClienteLabel": "TRILHA CLIENTE",
      "sub1Role": "SUB-AGENTE",
      "sub1Name": "Broker Collector",
      "sub1Desc": "Coleta feedback do corretor",
      "sub2Role": "SUB-AGENTE",
      "sub2Name": "Audio Processor",
      "sub2Desc": "Transcreve e interpreta audio",
      "sub3Role": "SUB-AGENTE",
      "sub3Name": "CRM Writer",
      "sub3Desc": "Registra tudo no Salesforce",
      "sub4Role": "SUB-AGENTE",
      "sub4Name": "Client Surveyor",
      "sub4Desc": "Pesquisa pos-visita cliente",
      "sub5Role": "SUB-AGENTE",
      "sub5Name": "Score Calculator",
      "sub5Desc": "Recalcula lead scoring",
      "tech1": "WhatsApp Business API",
      "tech2": "Audio + NLP Engine",
      "tech3": "Salesforce API",
      "tech4": "WhatsApp + NPS",
      "tech5": "Custom Scoring Model",
      "flowLine1": "Trilha A: Booking → Fim do dia → WhatsApp corretor → Transcreve audio → Registra atendimento",
      "flowLine2": "Trilha B: Booking → Fim do dia → Perguntas rapidas ao cliente → Avaliação NPS → Combina dados → Recalcula Score"
    }
  },
  "logoStrip": {
    "label": "Trabalhos entregues por essa equipe",
    "clients": [
      {
        "name": "SIS Segurança Privada",
        "relation": "Pilot Bravic"
      },
      {
        "name": "Newave Capital",
        "relation": "Pilot Bravic"
      },
      {
        "name": "JHSF Participações",
        "relation": "via Sugar Cane Tech"
      },
      {
        "name": "Scoder Tech Studio",
        "relation": "via Sugar Cane Tech"
      }
    ]
  },
  "platform": {
    "label": "Diferencial",
    "headingPrefix": "A Tecnologia ",
    "headingSuffix": "",
    "lede": "Tecnologia proprietária de orquestração de agentes enterprise, construída internamente para dar controle sobre o que mais importa: segurança, integrações, observabilidade, compliance e evolução contínua.",
    "lede2": "É nessa fundação que cada agente é desenhado, conectado aos sistemas do cliente e acompanhado em produção.",
    "lede3": "Não dependemos do roadmap de uma ferramenta de terceiros. A mesma equipe que constrói a solução também controla a plataforma, a arquitetura e a evolução técnica por trás dela.",
    "pillars": [
      {
        "title": "Proprietária por escolha",
        "description": "A Plataforma Bravic foi construída internamente para que cada implementação tenha mais controle, flexibilidade e profundidade técnica. Adaptamos integrações, regras, fluxos e camadas de segurança conforme a realidade de cada cliente, sem depender das limitações ou prioridades de uma plataforma externa."
      },
      {
        "title": "Model-agnostic",
        "description": "OpenAI, Anthropic, Google e modelos open-source podem ser avaliados caso a caso, considerando performance, custo, segurança e adequação ao processo. Quando o melhor modelo muda, a plataforma muda junto, sem reconstruir toda a operação."
      },
      {
        "title": "Fundação horizontal",
        "description": "A primeira implementação cria a base técnica da operação: integrações, infraestrutura, permissões, regras e governança. A partir dessa fundação, novos agentes e casos de uso podem ser ativados com mais velocidade, previsibilidade e menor esforço incremental. O segundo agente não começa do zero."
      },
      {
        "title": "Arquitetura enterprise",
        "description": "Com stack moderna, documentação, separação de ambientes e estrutura preparada para auditoria, a plataforma suporta integrações sensíveis, validações de compliance e parcerias formais com provedores de IA."
      }
    ]
  },
  "trust": {
    "label": "Governança",
    "heading": "Agentes de IA Enterprise alinhados ao compliance.",
    "description": "A Bravic desenha cada orquestração considerando políticas internas, requisitos de compliance, critérios de segurança, rastreabilidade, permissões de acesso e processos de aprovação. A inteligência opera dentro dos limites definidos pela organização.",
    "items": [
      {
        "icon": "rule",
        "title": "Compliance by design",
        "description": "A orquestração dos agentes é desenhada a partir das regras, políticas e critérios de aprovação da sua empresa."
      },
      {
        "icon": "security",
        "title": "Segurança operacional",
        "description": "Cada agente é construído para operar com controle de acesso, separação de ambientes, logs, rastreabilidade e validações antes de interagir com sistemas críticos.\n\nA IA não atua como uma caixa-preta. Cada ação precisa ser visível, auditável e governada."
      },
      {
        "icon": "science",
        "title": "Ambientes controlados",
        "description": "Toda integração começa em sandbox, com testes isolados e critérios claros para promoção para produção. Nenhum agente toca a operação real sem validação técnica."
      },
      {
        "icon": "fact_check",
        "title": "Auditoria",
        "description": "A arquitetura, os fluxos, as integrações e os pontos de controle são documentados para facilitar revisões internas, auditorias e validações com áreas de TI, jurídico, segurança e compliance."
      }
    ],
    "cta": {
      "description": "Tem requisitos específicos de compliance ou segurança? Vamos desenhar juntos a orquestração que atende ao seu padrão.",
      "button": "Falar com a Bravic"
    }
  },
  "seo": {
    "tagline": "Inteligência que opera",
    "defaultDescription": "Bravic é uma Enterprise Agent Platform model-agnostic. Do Assessment ao Operate, colocamos agentes de IA em produção em até 4 semanas, com Agent Engineer embarcado.",
    "home": {
      "title": "Orquestração de agentes de IA enterprise",
      "description": "Plataforma de agentes de IA model-agnostic + Agent Engineer embarcado. Do diagnóstico estratégico à operação contínua, com integrações reais ao seu ERP, CRM e sistemas internos."
    },
    "manifesto": {
      "title": "Manifesto",
      "description": "O que defendemos sobre IA aplicada à operação enterprise: orquestração como produto, plataforma model-agnostic e operação contínua como condição inegociável."
    },
    "about": {
      "title": "Quem somos",
      "description": "Conheça os fundadores e o time da Bravic — engenheiros, operadores e estrategistas que colocam agentes de IA em produção em empresas brasileiras."
    },
    "roadmap": {
      "title": "O que fazemos: Assessment, Build, Operate",
      "description": "Três fases para colocar IA em produção. Assessment gera AI Score e business case. Build entrega agentes integrados ao seu ERP/CRM. Operate é refinamento contínuo com Agent Engineer embarcado."
    },
    "contact": {
      "title": "Fale com a Bravic",
      "description": "Agende um Assessment ou converse com nosso time. Resposta em até um dia útil."
    },
    "institucional": {
      "title": "Apresentação institucional",
      "description": "Visão completa da Bravic: posicionamento, plataforma, modelo operacional, cases e metodologia."
    },
    "caseScoder": {
      "title": "Case Scoder — 144h/mês eliminadas no fechamento",
      "description": "Como a Bravic substituiu o fechamento manual da Scoder com agentes de IA conectados ao ERP, eliminando 144 horas operacionais por mês."
    },
    "caseJhsf": {
      "title": "Case JHSF — registro de atendimento de 38% para 97%",
      "description": "Como a Bravic levou o registro de atendimento da JHSF Participações de 38% para 97% com orquestração de agentes integrada ao CRM."
    },
    "privacy": {
      "title": "Política de Privacidade",
      "description": "Como a Bravic coleta, usa, armazena e protege dados pessoais e dados acessados via integrações Google e Microsoft (perfil, e-mail, Google Drive, OneDrive e SharePoint)."
    },
    "terms": {
      "title": "Termos de Uso",
      "description": "Termos e condições de uso dos serviços, plataforma e site da Bravic, incluindo regras de acesso, propriedade intelectual e responsabilidades."
    }
  },
  "legal": {
    "common": {
      "lastUpdatedLabel": "Última atualização",
      "tocLabel": "Sumário",
      "backToTop": "Voltar ao topo"
    },
    "privacy": {
      "title": "Política de Privacidade",
      "lastUpdated": "9 de maio de 2026",
      "intro": [
        "Esta Política de Privacidade descreve como a <strong>Bravic</strong>, (\"Bravic\", \"nós\"), coleta, utiliza, armazena, compartilha e protege dados pessoais ao oferecer seus serviços, sua plataforma de orquestração de agentes de IA e este site (<a href=\"https://bravicglobal.com\">bravicglobal.com</a>).",
        "Esta política também descreve como tratamos dados acessados a partir de contas Google e Microsoft quando o cliente autoriza a Bravic a se integrar a esses serviços via OAuth 2.0. O tratamento observa a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD), o Marco Civil da Internet (Lei nº 12.965/2014), a Google API Services User Data Policy (incluindo o requisito de Limited Use) e os termos da Microsoft Graph API.",
        "Ao utilizar nossos serviços ou autorizar a integração com Google e/ou Microsoft, você declara ter lido e concordado com esta Política."
      ],
      "sections": [
        {
          "id": "controller",
          "title": "1. Controlador e Encarregado (DPO)",
          "paragraphs": [
            "<strong>Controlador:</strong> Bravic.",
            "<strong>Encarregado pelo Tratamento de Dados Pessoais (DPO):</strong> dpo@bravicglobal.com.",
            "Para qualquer dúvida, requisição de titular ou comunicação relacionada à privacidade, utilize o canal <a href=\"mailto:privacidade@bravicglobal.com.br\">privacidade@bravicglobal.com.br</a>."
          ]
        },
        {
          "id": "scope",
          "title": "2. Abrangência",
          "paragraphs": [
            "Esta Política aplica-se: (i) ao site institucional da Bravic; (ii) à Plataforma Bravic (Enterprise Agent Platform) e aos agentes de IA por nós operados em produção; (iii) às integrações com serviços de terceiros autorizadas pelo cliente, incluindo Google Workspace (Drive, e-mail, perfil) e Microsoft 365 (OneDrive, SharePoint, perfil)."
          ]
        },
        {
          "id": "data-we-collect",
          "title": "3. Dados que coletamos",
          "paragraphs": [
            "<strong>3.1 Dados fornecidos diretamente.</strong> Nome, e-mail corporativo, telefone, empresa, cargo e mensagem, quando você preenche formulários de contato, agenda Assessment ou se cadastra na Plataforma Bravic.",
            "<strong>3.2 Dados coletados automaticamente.</strong> Endereço IP, identificadores de dispositivo, tipo de navegador, sistema operacional, páginas visitadas, data e hora de acesso, referenciador e dados de cookies estritamente necessários e analíticos.",
            "<strong>3.3 Dados acessados via Google OAuth.</strong> Quando o cliente autoriza, a Bravic acessa: (a) <em>perfil básico e e-mail</em> (escopos <code>openid</code>, <code>profile</code>, <code>email</code>) — nome, endereço de e-mail, identificador de conta e foto de perfil para autenticação e identificação do usuário; (b) <em>Google Drive</em> (escopos como <code>drive.file</code>, <code>drive.readonly</code> ou <code>drive</code>, conforme o caso de uso autorizado) — leitura, criação ou organização de arquivos e metadados estritamente necessários à automação contratada.",
            "<strong>3.4 Dados acessados via Microsoft OAuth (Microsoft Graph).</strong> Quando o cliente autoriza, a Bravic acessa: (a) <em>perfil básico</em> (escopo <code>User.Read</code>) — nome, e-mail e identificador da conta; (b) <em>OneDrive e SharePoint</em> (escopos como <code>Files.Read</code>, <code>Files.ReadWrite</code>, <code>Sites.Read.All</code>, <code>Sites.ReadWrite.All</code>, conforme o caso de uso autorizado) — leitura, criação ou organização de arquivos, sites e bibliotecas de documentos estritamente necessários à automação contratada.",
            "<strong>3.5 Dados de operação dos agentes.</strong> Logs de execução, prompts, respostas, métricas de qualidade, custo por token, exceções e auditoria, com finalidade de operar, monitorar e melhorar os agentes contratados.",
            "Não coletamos dados sensíveis (origem racial, opinião política, religião, saúde, biometria etc.) salvo se estritamente necessário e expressamente autorizado pelo cliente em contrato específico."
          ]
        },
        {
          "id": "google-limited-use",
          "title": "4. Uso de dados do Google (Google API Services User Data Policy)",
          "paragraphs": [
            "O uso, pela Bravic, de informações recebidas de Google APIs adere à <a href=\"https://developers.google.com/terms/api-services-user-data-policy\" target=\"_blank\" rel=\"noopener noreferrer\">Google API Services User Data Policy</a>, incluindo os requisitos de <strong>Limited Use</strong>. Em particular:",
            "<ul><li>usamos os dados acessados via Google APIs <strong>apenas</strong> para fornecer e melhorar as funcionalidades de automação contratadas pelo cliente que concedeu o acesso;</li><li><strong>não</strong> usamos dados de Google Workspace APIs (incluindo Gmail, Drive, Calendar e Contacts) para desenvolver, treinar ou melhorar modelos de IA/ML generalizados ou não-personalizados;</li><li><strong>não</strong> transferimos esses dados a terceiros, exceto (i) conforme estritamente necessário para fornecer e melhorar o serviço contratado, (ii) por exigência legal, ou (iii) com consentimento expresso e específico do usuário;</li><li><strong>não</strong> usamos esses dados para servir publicidade, incluindo publicidade direcionada ou baseada em interesse;</li><li><strong>não</strong> permitimos que humanos leiam esses dados, salvo (i) com consentimento expresso e específico do usuário, (ii) quando necessário por motivos de segurança (ex.: investigação de abuso), (iii) para cumprir obrigação legal, ou (iv) quando os dados foram agregados e anonimizados para operação interna.</li></ul>"
          ]
        },
        {
          "id": "microsoft-data",
          "title": "5. Uso de dados da Microsoft (Microsoft Graph)",
          "paragraphs": [
            "Tratamos os dados acessados via Microsoft Graph em conformidade com os <a href=\"https://learn.microsoft.com/graph/security-concept-overview\" target=\"_blank\" rel=\"noopener noreferrer\">termos da plataforma Microsoft</a> e com os princípios de privacidade aqui descritos. Em particular:",
            "<ul><li>usamos dados de OneDrive, SharePoint e perfil <strong>apenas</strong> para entregar a automação contratada pelo cliente que concedeu o acesso;</li><li><strong>não</strong> usamos esses dados para treinar modelos de IA/ML generalizados, nem para publicidade;</li><li>respeitamos os escopos mínimos (princípio do menor privilégio) — solicitamos apenas os escopos necessários para o caso de uso autorizado;</li><li>o cliente pode revogar o acesso a qualquer momento pelo painel da Microsoft (Minha Conta → Aplicativos & serviços) ou pelas configurações do tenant.</li></ul>"
          ]
        },
        {
          "id": "purposes",
          "title": "6. Finalidades e bases legais",
          "paragraphs": [
            "Tratamos dados pessoais para as seguintes finalidades, com as seguintes bases legais (LGPD, art. 7º):",
            "<ul><li><strong>Execução de contrato e procedimentos preliminares</strong> (art. 7º, V): autenticar usuários, operar agentes em produção, executar integrações autorizadas e prestar suporte;</li><li><strong>Cumprimento de obrigação legal e regulatória</strong> (art. 7º, II): atendimento à LGPD, normas fiscais, contábeis e de prevenção a fraudes;</li><li><strong>Legítimo interesse</strong> (art. 7º, IX): segurança da informação, prevenção a abuso, melhoria contínua dos serviços e comunicação institucional B2B compatível com a expectativa do titular;</li><li><strong>Consentimento</strong> (art. 7º, I): comunicações de marketing opt-in e cookies não essenciais;</li><li><strong>Exercício regular de direitos</strong> (art. 7º, VI): em processos judiciais, administrativos ou arbitrais.</li></ul>"
          ]
        },
        {
          "id": "sharing",
          "title": "7. Compartilhamento e operadores (sub-processadores)",
          "paragraphs": [
            "A Bravic compartilha dados pessoais apenas quando necessário, com:",
            "<ul><li><strong>Provedores de infraestrutura</strong> (cloud, hospedagem, observabilidade): para hospedar a Plataforma e processar dados do cliente;</li><li><strong>Provedores de modelos de IA</strong> (Anthropic, OpenAI, Google, entre outros): conforme o cliente autorizar e respeitando as configurações de retenção e treinamento de cada provedor;</li><li><strong>Ferramentas operacionais</strong> (e-mail transacional, CRM, suporte): exclusivamente para operação da relação contratual;</li><li><strong>Autoridades públicas</strong>: quando exigido por lei, ordem judicial ou para defesa de direitos.</li></ul>",
            "Não vendemos dados pessoais. Mantemos uma lista de sub-processadores atualizada e disponível mediante solicitação ao DPO."
          ]
        },
        {
          "id": "transfers",
          "title": "8. Transferências internacionais",
          "paragraphs": [
            "Alguns sub-processadores estão localizados fora do Brasil. Sempre que houver transferência internacional, garantimos as salvaguardas exigidas pelo art. 33 da LGPD, incluindo cláusulas contratuais padrão e adequação a regimes equivalentes."
          ]
        },
        {
          "id": "retention",
          "title": "9. Retenção e eliminação",
          "paragraphs": [
            "Retemos dados pessoais apenas pelo tempo necessário às finalidades para as quais foram coletados ou conforme exigido por lei. Em geral: dados de contato comercial por até 5 anos após o último contato; dados operacionais e logs de agentes pelo prazo previsto em contrato com o cliente; dados de cookies analíticos por até 13 meses.",
            "Após o término do contrato ou revogação do consentimento, eliminamos ou anonimizamos os dados, salvo quando obrigados a retê-los por dever legal."
          ]
        },
        {
          "id": "security",
          "title": "10. Segurança da informação",
          "paragraphs": [
            "Adotamos medidas técnicas e organizacionais compatíveis com o estado da arte, incluindo: criptografia em trânsito (TLS 1.2+) e em repouso, controle de acesso baseado em papéis (RBAC), segregação de ambientes, princípio do menor privilégio, registro de auditoria, gestão de segredos, revisão de código e plano de resposta a incidentes.",
            "Em caso de incidente de segurança que possa acarretar risco ou dano relevante aos titulares, comunicaremos a ANPD e os titulares afetados em prazo razoável, conforme art. 48 da LGPD."
          ]
        },
        {
          "id": "cookies",
          "title": "11. Cookies",
          "paragraphs": [
            "Utilizamos cookies estritamente necessários (autenticação, segurança), cookies de preferência (idioma) e cookies analíticos para entender o uso do site. Você pode bloquear ou apagar cookies pelas configurações do navegador. O bloqueio de cookies essenciais pode comprometer o funcionamento do site."
          ]
        },
        {
          "id": "rights",
          "title": "12. Direitos do titular",
          "paragraphs": [
            "Nos termos do art. 18 da LGPD (e dos arts. 15-22 do GDPR, quando aplicável), você tem direito a: confirmação da existência de tratamento; acesso aos dados; correção de dados incompletos, inexatos ou desatualizados; anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade; portabilidade; eliminação dos dados tratados com base no consentimento; informação sobre compartilhamentos; revogação do consentimento; e oposição a tratamento realizado com base em outras hipóteses legais.",
            "Para exercer qualquer direito, escreva para <a href=\"mailto:privacidade@bravicglobal.com\">privacidade@bravicglobal.com</a>. Responderemos em até 15 dias.",
            "<strong>Revogação de acesso a Google/Microsoft:</strong> você pode revogar a autorização concedida à Bravic a qualquer momento em <a href=\"https://myaccount.google.com/permissions\" target=\"_blank\" rel=\"noopener noreferrer\">myaccount.google.com/permissions</a> (Google) ou em <a href=\"https://myaccount.microsoft.com/\" target=\"_blank\" rel=\"noopener noreferrer\">myaccount.microsoft.com</a> (Microsoft)."
          ]
        },
        {
          "id": "children",
          "title": "13. Crianças e adolescentes",
          "paragraphs": [
            "Nossos serviços são B2B e direcionados a profissionais maiores de 18 anos. Não coletamos intencionalmente dados de crianças e adolescentes. Caso identifiquemos coleta indevida, eliminaremos os dados imediatamente."
          ]
        },
        {
          "id": "updates",
          "title": "14. Alterações desta Política",
          "paragraphs": [
            "Podemos atualizar esta Política para refletir mudanças legais, técnicas ou operacionais. A versão vigente é sempre a publicada nesta página, com a data de \"Última atualização\" indicada acima. Alterações materiais serão comunicadas previamente pelos canais cadastrados."
          ]
        },
        {
          "id": "contact",
          "title": "15. Contato",
          "paragraphs": [
            "Dúvidas, requisições de titular ou comunicações sobre privacidade: <a href=\"mailto:privacidade@bravicglobal.com\">privacidade@bravicglobal.com</a>.",
            "Você também pode apresentar reclamação à Autoridade Nacional de Proteção de Dados (ANPD) em <a href=\"https://www.gov.br/anpd\" target=\"_blank\" rel=\"noopener noreferrer\">gov.br/anpd</a>."
          ]
        }
      ]
    },
    "terms": {
      "title": "Termos de Uso",
      "lastUpdated": "9 de maio de 2026",
      "intro": [
        "Estes Termos de Uso (\"Termos\") regulam o acesso e o uso dos serviços, da plataforma e do site da <strong>Bravic</strong>, (\"Bravic\", \"nós\"), incluindo a Plataforma Bravic (Enterprise Agent Platform) e o site <a href=\"https://bravicglobal.com\">bravicglobal.com</a>.",
        "Ao acessar, navegar ou contratar nossos serviços, você (\"Usuário\" ou \"Cliente\") declara ter lido, compreendido e concordado integralmente com estes Termos e com a nossa <a href=\"/privacy\">Política de Privacidade</a>. Se você não concorda, não utilize os serviços."
      ],
      "sections": [
        {
          "id": "definitions",
          "title": "1. Definições",
          "paragraphs": [
            "<strong>Plataforma:</strong> ambiente proprietário da Bravic para orquestrar agentes de IA conectados a sistemas do Cliente.",
            "<strong>Agente:</strong> sistema baseado em modelos de linguagem, regras de negócio e integrações, executado pela Plataforma sob supervisão do Agent Engineer da Bravic.",
            "<strong>Serviços:</strong> Assessment, Build, Operate, acesso à Plataforma e quaisquer outros entregáveis previstos em contrato específico (\"Contrato\")."
          ]
        },
        {
          "id": "eligibility",
          "title": "2. Elegibilidade",
          "paragraphs": [
            "Os Serviços são destinados exclusivamente a pessoas jurídicas e profissionais maiores de 18 anos com capacidade de contratar. Ao aceitar estes Termos em nome de uma empresa, você declara possuir poderes para vinculá-la."
          ]
        },
        {
          "id": "account",
          "title": "3. Cadastro e conta",
          "paragraphs": [
            "Para utilizar a Plataforma, o Cliente deverá fornecer informações verdadeiras, completas e atualizadas. O Cliente é responsável pela confidencialidade das credenciais e por todas as atividades realizadas em sua conta. Em caso de uso não autorizado, comunique imediatamente <a href=\"mailto:seguranca@bravicglobal.com\">seguranca@bravicglobal.com</a>."
          ]
        },
        {
          "id": "license",
          "title": "4. Licença de uso",
          "paragraphs": [
            "Sujeito ao cumprimento destes Termos e do Contrato, a Bravic concede ao Cliente uma licença limitada, não exclusiva, intransferível e revogável para acessar e utilizar a Plataforma e os Agentes contratados, exclusivamente para fins de operação interna do Cliente, durante a vigência contratual."
          ]
        },
        {
          "id": "acceptable-use",
          "title": "5. Uso aceitável",
          "paragraphs": [
            "É vedado ao Usuário:",
            "<ul><li>utilizar a Plataforma para fins ilícitos, fraudulentos ou que violem direitos de terceiros;</li><li>tentar acessar áreas restritas, contornar medidas de segurança, fazer engenharia reversa ou descompilar a Plataforma;</li><li>introduzir malware, código malicioso ou realizar ataques de qualquer natureza;</li><li>utilizar a Plataforma para gerar conteúdo proibido por lei, incluindo conteúdo discriminatório, violento, sexualmente explícito envolvendo menores ou que viole direitos de propriedade intelectual;</li><li>revender, sublicenciar ou disponibilizar os Serviços a terceiros sem autorização expressa;</li><li>extrair dados de forma automatizada (scraping) que comprometa a integridade ou disponibilidade dos Serviços.</li></ul>"
          ]
        },
        {
          "id": "client-data",
          "title": "6. Dados do Cliente e integrações com terceiros",
          "paragraphs": [
            "O Cliente é o controlador dos dados pessoais que disponibiliza à Bravic e é responsável pela legalidade da coleta e do compartilhamento. A Bravic atua como operadora, observando o Contrato, esta Política, a LGPD e os termos das plataformas integradas (Google, Microsoft etc.).",
            "Ao conectar contas Google ou Microsoft à Plataforma, o Cliente autoriza a Bravic a acessar os escopos OAuth solicitados e descritos na <a href=\"/privacy\">Política de Privacidade</a>, exclusivamente para a finalidade contratada. O Cliente pode revogar o acesso a qualquer momento."
          ]
        },
        {
          "id": "ip",
          "title": "7. Propriedade intelectual",
          "paragraphs": [
            "Todos os direitos de propriedade intelectual sobre a Plataforma, sua arquitetura, código-fonte, marcas, identidade visual, documentação e materiais derivados são de titularidade exclusiva da Bravic ou de seus licenciadores. Nenhuma disposição destes Termos transfere ao Cliente direitos sobre tais ativos, exceto a licença limitada de uso descrita na cláusula 4."
          ]
        },
        {
          "id": "third-parties",
          "title": "8. Serviços de terceiros",
          "paragraphs": [
            "A Plataforma pode integrar-se a serviços de terceiros (modelos de IA, provedores de cloud, Google Workspace, Microsoft 365, sistemas internos do Cliente). A Bravic não é responsável por indisponibilidades, falhas, alterações de termos ou políticas de tais terceiros. O uso desses serviços está sujeito aos respectivos termos."
          ]
        },
        {
          "id": "fees",
          "title": "9. Preços e pagamento",
          "paragraphs": [
            "Os valores, condições de pagamento, reajustes e tributos aplicáveis são definidos em Contrato específico. O atraso no pagamento poderá ensejar suspensão do acesso e cobrança de encargos previstos contratualmente."
          ]
        },
        {
          "id": "warranties",
          "title": "10. Garantias e disponibilidade",
          "paragraphs": [
            "A Bravic envida esforços comerciais razoáveis para manter a Plataforma disponível e segura, observando o SLA específico previsto em Contrato. Os Serviços são prestados \"como estão\" no que se refere a aspectos não cobertos por SLA, e a Bravic não garante que estarão livres de erros ou interrupções."
          ]
        },
        {
          "id": "liability",
          "title": "11. Limitação de responsabilidade",
          "paragraphs": [
            "Na máxima extensão permitida pela legislação aplicável, a responsabilidade total da Bravic, em qualquer hipótese, fica limitada ao valor efetivamente pago pelo Cliente nos 12 meses anteriores ao evento que deu causa à responsabilidade. A Bravic não responde por danos indiretos, lucros cessantes, perda de chance, perda de dados ou interrupção de negócios."
          ]
        },
        {
          "id": "termination",
          "title": "12. Vigência e rescisão",
          "paragraphs": [
            "Estes Termos vigoram enquanto o Cliente utilizar os Serviços. A Bravic pode suspender ou encerrar o acesso em caso de descumprimento destes Termos ou do Contrato, ordem judicial ou ameaça à segurança da Plataforma. Cláusulas relativas a propriedade intelectual, confidencialidade, limitação de responsabilidade e foro sobrevivem ao término."
          ]
        },
        {
          "id": "changes",
          "title": "13. Alterações",
          "paragraphs": [
            "A Bravic pode atualizar estes Termos a qualquer tempo. A versão vigente é sempre a publicada nesta página, com a data de \"Última atualização\". Alterações materiais serão comunicadas previamente pelos canais cadastrados, ressalvado o disposto em Contrato específico."
          ]
        },
        {
          "id": "law",
          "title": "14. Lei aplicável e foro",
          "paragraphs": [
            "Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da Comarca de São Paulo/SP para dirimir quaisquer controvérsias, com renúncia a qualquer outro, por mais privilegiado que seja, ressalvada disposição em contrário no Contrato específico."
          ]
        },
        {
          "id": "contact",
          "title": "15. Contato",
          "paragraphs": [
            "Dúvidas sobre estes Termos: <a href=\"mailto:contato@bravicglobal.com\">contato@bravicglobal.com</a>."
          ]
        }
      ]
    }
  },
  "notFound": {
    "title": "Página não encontrada",
    "heading": "Essa página saiu do ar.",
    "description": "O link pode estar desatualizado ou o conteúdo foi movido. Volte para a home e continue a navegação.",
    "cta": "Voltar para a home"
  }
}
